// extracted by mini-css-extract-plugin
module.exports = {"Message":"CustomToast_Message__3e1Bp"};